import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogModule } from 'primeng/primeng';

import { OverlayDialogComponent } from './overlay-dialog/overlay-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    DialogModule
  ],
  declarations: [
    OverlayDialogComponent
  ],
  exports: [
    CommonModule,
    DialogModule,

    OverlayDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FragmentsModule { }
